import React from "react";
import { motion } from "framer-motion";

import img1 from '../../assets/images/engineer-4915797_1280.jpg';
import img2 from '../../assets/images/train-143847_1280.jpg';
import img3 from '../../assets/images/auto-parts-4753077_1280.jpg';
import img4 from '../../assets/images/agriculture-5437592_1280.jpg';
import img5 from '../../assets/images/ev-5704430_1280.jpg';
import img6 from '../../assets/images/old-2416219_1280.jpg';
import img7 from '../../assets/images/military-4077568_1280.jpg';
import img8 from '../../assets/images/construction-7226875.jpg';

const industries = [
  { title: "Engineering", image: img1 },
  { title: "Locomotive(Railways)", image: img2 },
  { title: "Auto Ancillaries", image: img3 },
  { title: "Agriculture Equipments", image: img4 },
  { title: "Automotive Electric Vehicles (EV)", image: img5 },
  { title: "Automotive Internal Combustion Engine (ICE)", image: img6 },
  { title: "Defense", image: img7 },
  { title: "Infrastructure", image: img8 },
];

export default function IndustriesGrid() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="py-12 px-4 bg-gray-100"
    >
      <h2 className="text-5xl font-bold text-center mb-10 text-gray-800">
        Industries We Serve
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {industries.map((industry, index) => (
          <motion.div
            key={index}
            className="relative group overflow-hidden rounded-2xl shadow-md bg-white"
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <img
              src={industry.image}
              alt={industry.title}
              className="w-full h-60 object-cover transform group-hover:scale-110 transition duration-500"
            />
            <div className="text-center py-4 text-lg font-semibold" style={{ color: 'rgb(44, 62, 80)' }}>
              {industry.title}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
}
